"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_instantsearch_dom_1 = require("react-instantsearch-dom");
var react_1 = __importDefault(require("react"));
var sortBy_1 = __importDefault(require("lodash/sortBy"));
exports.default = react_instantsearch_dom_1.connectRefinementList(function (_a) {
    var items = _a.items, refine = _a.refine, attribute = _a.attribute;
    var sortedItems = items.sort(function (a, b) { return (window.__(a.label) > window.__(b.label)) ? 1 : -1; });
    if (attribute === 'residence_categories') {
        sortedItems = sortBy_1.default(items, function (item) {
            return [
                'premium-living',
                'woonzorgcentrum',
                'assistentiewoningen',
                'dringende-opname',
                'kortverblijf',
                'herstelverblijf',
                'tijdelijk-verblijf',
            ].indexOf(item.label);
        });
    }
    return (react_1.default.createElement("div", { className: "ais-RefinementList" },
        react_1.default.createElement("ul", { className: "ais-RefinementList-list" }, sortedItems.map(function (item) { return (react_1.default.createElement("li", { key: item.label, className: "ais-RefinementList-item ais-RefinementList-item--selected" },
            react_1.default.createElement("label", { className: "ais-RefinementList-label", onClick: function (e) {
                    e.preventDefault();
                    refine(item.value);
                } },
                react_1.default.createElement("input", { className: "ais-RefinementList-checkbox " + (item.isRefined ? 'ais-RefinementList-checkbox--checked' : ''), type: "checkbox", checked: item.isRefined, value: item.value }),
                react_1.default.createElement("span", { className: "ais-RefinementList-labelText" }, window.__(item.label)),
                react_1.default.createElement("span", { className: "ais-RefinementList-count" }, item.count)))); }))));
});
